import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Active branch header · leído de localStorage en cada request para que
  // el cambio de sucursal aplique sin recargar.
  wootApi.interceptors.request.use(config => {
    try {
      const raw = window.localStorage.getItem('cw-active-branch-id');
      const id = Number(raw);
      if (Number.isFinite(id) && id > 0) {
        config.headers['X-Active-Branch-Id'] = id;
      }
    } catch (_) {
      /* localStorage puede no estar disponible · ignoramos */
    }
    return config;
  });

  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
